export default __webpack_public_path__ + "fonts/filter-left-arrow.svg";